import React, { useState, useContext, useEffect } from 'react';
import { Fab, Box, Toolbar, IconButton, Typography, Grid, Tooltip, Badge } from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import Avatar from '@mui/material/Avatar';
import FireIcon from '../../../public/images/flames.png';
import BellIcon from '../../../public/images/top_bar/bell_icon.webp';
import GreyFireIcon from '../../../public/images/top_bar/grey-fire-1.webp';
import PoliceManIcon from '../../../public/images/account_menu/policeman.svg';
import NotificationMenu from '../Menus/NotificationMenu';
import AccountMenu from '../Menus/AccountMenu';
import { StreakContext } from '../../../contexts/StreakContext';
import { Classes, StyledAppBar } from './Topbar.styles';
import { logoutUser } from '../../../store/actions/user';
import { useNotifications } from '../hooks/useNotifications'; // Import the generated hook

export function TopBar(props) {
	const [anchorEl, setAnchorEl] = useState(null);
	const [anchorNotification, setAnchorNotification] = useState(null);

	const { streak, userId } = useContext(StreakContext);

	const { notifications, unopenedCount, hasMore, fetchNextPage, refetch, handleMarkAsRead, reset } =
		useNotifications(userId);

	const handleClick = (event) => {
		setAnchorEl(event.currentTarget);
	};

	const handleClose = () => {
		setAnchorEl(null);
	};

	const handleNotificationClick = async (event) => {
		if (!anchorNotification) {
			// Only refetch if the menu is not already open
			if (notifications.length === 0) {
				await refetch();
			}
			setAnchorNotification(event.target);
		}
	};

	const handleCloseNotifications = () => {
		reset(); // Reset state in useNotifications except unopenedCount
		setAnchorNotification(null);
	};

	const handleLogout = () => {
		setAnchorEl(null);
		logoutUser();
	};
	return (
		<StyledAppBar color="default" className={Classes.appBar}>
			<Toolbar>
				<IconButton
					color="inherit"
					aria-label="open drawer"
					edge="start"
					onClick={props.handleDrawerToggle}
					className={Classes.menuButton}
					size="large"
				>
					<MenuIcon />
				</IconButton>
				<Box width="100%" display="flex" justifyContent="flex-end">
					<Box alignItems="center" display="flex" justifyContent="space-around">
						<Grid container>
							<Grid item xs={12} display="flex" justifyContent="flex-end">
								<Box display="flex" alignItems="center" justifyContent="center">
									<Typography variant="subtitle" fontSize="20px" fontWeight="bold">
										{streak && !streak?.Discontinued ? streak?.Count : 0}{' '}
									</Typography>
									<Tooltip title="Zile consecutive cu teste rezolvate" placement="bottom">
										<Box
											component="img"
											alt="fire"
											id="fireIcon"
											src={streak && !streak?.Discontinued ? FireIcon : GreyFireIcon}
											sx={{ height: '25px', width: '25px' }}
										/>
									</Tooltip>
								</Box>
								<Tooltip title="Notificari" placement="bottom">
									<IconButton onClick={handleNotificationClick}>
										<Badge
											badgeContent={unopenedCount}
											sx={{ pointerEvents: 'none' }}
											color="error"
										>
											<Box
												component="img"
												alt="bell"
												id="bellIcon"
												src={BellIcon}
												sx={{ height: '20px', width: '20px' }}
											/>
										</Badge>
									</IconButton>
								</Tooltip>
								<NotificationMenu
									anchorEl={anchorNotification}
									handleClose={handleCloseNotifications}
									notifications={notifications}
									fetchNotifications={fetchNextPage}
									markAsRead={handleMarkAsRead}
									hasMore={hasMore}
									refetch={refetch}
								/>
							</Grid>
						</Grid>

						<Avatar
							alt="Account menu"
							component={Fab}
							onClick={handleClick}
							className={Classes.avatar}
							src={PoliceManIcon}
						/>
						<AccountMenu
							anchorEl={anchorEl}
							setAnchorEl={setAnchorEl}
							handleClose={handleClose}
							handleLogout={handleLogout}
							handleDarkMode={props.toggleDarkMode}
						/>
					</Box>
				</Box>
			</Toolbar>
		</StyledAppBar>
	);
}

export default TopBar;
